import React from 'react';
import LoadingIndicator from '../../Search/SearchResultContainer/LoadingSearchIndicator';

function ProjectLoadingIndicator() {
  return (
    <div className="project-loading-container vh-100">
      <div className="g-row--always g-row--centered h-100">
        <LoadingIndicator />
      </div>
    </div>
  );
}

export default ProjectLoadingIndicator;
